var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Outlet, useNavigate } from 'react-router';
import { useContext, useEffect } from 'react';
import { ProductFilters } from './ProductFilters';
import { ConfigitProductContext } from '../../components/ConfigitProductProvider';
import { ApplicationContext } from '../../components/ApplicationProvider';
import { configureLayer as configureLayerAPI } from '../../services/ConfigitService';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ProductSearchHome = function () {
    var navigate = useNavigate();
    var _a = useContext(ConfigitProductContext), setSection = _a.setSection, section = _a.section, variableAssignments = _a.variableAssignments, selectedAttributeId = _a.selectedAttributeId, isAttributeSelected = _a.isAttributeSelected;
    var _b = useContext(ApplicationContext), loading = _b.loading, setLoading = _b.setLoading; // flag, trigger base model or apu
    var manufacturerProductEffect = function (newManufacturerProduct) { return __awaiter(void 0, void 0, void 0, function () {
        var _newManufacturerProdu, _newManufacturerProdu2, _newManufacturerProdu3, _newManufacturerProdu4, _newManufacturerProdu5, productFilterApplied, newSection, productId, manufacturerId, categoryId, approvedUseId, countryId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!loading)
                        setLoading(true);
                    productFilterApplied = false;
                    return [4 /*yield*/, configureLayerAPI(newManufacturerProduct, 'ProductSearchModel')];
                case 1:
                    newSection = _a.sent();
                    if (section !== newSection)
                        setSection(newSection);
                    productId = (_newManufacturerProdu = newManufacturerProduct.find(function (data) { return data.variableId === 'ManufacturedProduct_ComponentId'; })) === null || _newManufacturerProdu === void 0 ? void 0 : _newManufacturerProdu.value;
                    manufacturerId = (_newManufacturerProdu2 = newManufacturerProduct.find(function (data) { return data.variableId === 'Manufacturer_ManufacturerId'; })) === null || _newManufacturerProdu2 === void 0 ? void 0 : _newManufacturerProdu2.value;
                    categoryId = (_newManufacturerProdu3 = newManufacturerProduct.find(function (data) { return data.variableId === 'ManufacturedProduct_CategoryId'; })) === null || _newManufacturerProdu3 === void 0 ? void 0 : _newManufacturerProdu3.value;
                    approvedUseId = (_newManufacturerProdu4 = newManufacturerProduct.find(function (data) { return data.variableId === 'CApprovedUse_ApprovedUseId'; })) === null || _newManufacturerProdu4 === void 0 ? void 0 : _newManufacturerProdu4.value;
                    countryId = (_newManufacturerProdu5 = newManufacturerProduct.find(function (data) { return data.variableId === 'ManufacturedProduct_CountryId'; })) === null || _newManufacturerProdu5 === void 0 ? void 0 : _newManufacturerProdu5.value;
                    if (productId || manufacturerId || categoryId || approvedUseId || countryId) {
                        productFilterApplied = true;
                    }
                    if (productFilterApplied) {
                        navigate('./productSearchResults');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () { manufacturerProductEffect(variableAssignments); }, [JSON.stringify(variableAssignments)]);
    useEffect(function () { var getSection = function () { return __awaiter(void 0, void 0, void 0, function () { var newSection; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, configureLayerAPI(variableAssignments, 'ProductSearchModel')];
            case 1:
                newSection = _a.sent();
                if (section != newSection)
                    setSection(newSection);
                return [2 /*return*/];
        }
    }); }); }; getSection(); }, []);
    return /*#__PURE__*/ _jsx("main", { className: "main-content container-fluid flex-shrink-0 product-ui", children: /*#__PURE__*/ _jsxs("div", { className: "row h-100", children: [/*#__PURE__*/ _jsx("div", { className: "col-xl-3 col-lg-3 col-md-4 filters product-filters", children: /*#__PURE__*/ _jsx(ProductFilters, {}) }), /*#__PURE__*/ _jsx("div", { className: "col-xl-9 col-lg-9 col-md-8 h-100 product-outlet", children: /*#__PURE__*/ _jsx(Outlet, {}) })] }) });
};
